// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3ETRk","label":"Section_label__59Slf","contentWrap":"Section_contentWrap__39Sey","footer":"Section_footer__3SYT0","footerInner":"Section_footerInner__2C1Ja"};